import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
import * as appTypes from '@/store/actions/app'
import languages from './languages'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: appTypes.APP_DEFAULT_LANGUAGE,
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('es_ES').create(languages['es_ES']),
    new MLanguage('en_GB').create(languages['en_GB']),
    new MLanguage('ca_ES').create(languages['ca_ES'])
  ]
})



// WEBPACK FOOTER //
// ./src/language/index.js